import { useNavigate } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';
import './Breadcrumb.css';

const Breadcrumb = ({ items }) => {
  const navigate = useNavigate();

  return (
    <nav className="breadcrumb" aria-label="Fil d'Ariane">
      <ol className="breadcrumb-list" itemScope itemType="https://schema.org/BreadcrumbList">
        <li 
          className="breadcrumb-item" 
          itemProp="itemListElement" 
          itemScope 
          itemType="https://schema.org/ListItem"
        >
          <button 
            onClick={() => navigate('/')} 
            className="breadcrumb-link"
            itemProp="item"
          >
            <Home size={16} />
            <span itemProp="name">Accueil</span>
          </button>
          <meta itemProp="position" content="1" />
        </li>
        
        {items.map((item, index) => (
          <li 
            key={index}
            className="breadcrumb-item"
            itemProp="itemListElement" 
            itemScope 
            itemType="https://schema.org/ListItem"
          >
            <ChevronRight size={16} className="breadcrumb-separator" />
            {item.link ? (
              <button 
                onClick={() => navigate(item.link)} 
                className="breadcrumb-link"
                itemProp="item"
              >
                <span itemProp="name">{item.label}</span>
              </button>
            ) : (
              <span className="breadcrumb-current" itemProp="name">{item.label}</span>
            )}
            <meta itemProp="position" content={index + 2} />
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
